import { render, staticRenderFns } from "./AddOrUpdateFreight.vue?vue&type=template&id=54f3fd3c&scoped=true"
import script from "./AddOrUpdateFreight.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateFreight.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateFreight.vue?vue&type=style&index=0&id=54f3fd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3fd3c",
  null
  
)

export default component.exports